<template>
  <div class="container" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.ROOT">
    <div class="title" v-if="!guardado" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.TITLE">
      {{ $t("GARANTIAS_registro_instalacion") }}
    </div>

    <div class="container_cards" v-if="!guardado">
      <el-card class="cardEquipo" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SECTION_DATOS_EQUIPO">
        <div class="grid cardBody">
          <div class="cardTitle gridItem">
            {{ $t("GARANTIAS_datos_equipo") }}
          </div>

          <NumeroSerieInput
            :name="'nro_serie'"
            :label="$t('GARANTIAS_ns_a_registrar')"
            v-model="nro_serie"
            :onChange="this.onNumeroSerieChange"
            :disabled="formularioBloqueado"
            :customClases="'nro_serie gridItem'"
            :testIdInput="TEST_ID.GARANTIAS_REGISTRAR.NS_REGISTRAR_INPUT"
            :testIdDescription="TEST_ID.GARANTIAS_REGISTRAR.NS_REGISTRAR_DESCRIPTION"
            @cargaSerieCompleta="cargaSerieCompleta"
          />

          <div class="patente gridItem">
            <div class="patenteContainer">
              <div class="label">{{ $t("GARANTIAS_asociar_elementos") }}</div>
              <el-switch
                :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SWITCH_ASOCIAR_ELEMENTO"
                class="switch"
                v-model="asociarElemento"
                :disabled="formularioBloqueado"
                size="small"
              />
            </div>

            <NumeroSerieInput
              v-if="asociarElemento"
              :name="'nro_serie_asoc'"
              :label="$t('GARANTIAS_numero_serie')"
              v-model="nro_serie_asoc"
              :onChange="this.onNumeroSerieChange"
              :disabled="formularioBloqueado"
              :customClases="'nro_serie gridItem'"
            />
          </div>

          <div class="fec_instalacion gridItem" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.INPUT_FECHA_INSTALACION">
            <div class="label">{{ $t("GARANTIAS_fecha_instalacion") }}</div>
            <el-date-picker
              v-model="fec_instalacion"
              :disabled="formularioBloqueado"
              type="date"
              size="small"
              format="DD/MM/YYYY"
              suffix-icon="Calendar"
            />
          </div>
          <div class="patente gridItem">
            <div class="patenteContainer">
              <div class="label">
                {{
                  tienePatente
                    ? $t("GARANTIAS_patente")
                    : $t("GARANTIAS_marca_modelo")
                }}
              </div>
              <el-switch :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SWITCH_TIENE_PATENTE" class="switch" v-model="tienePatente" :disabled="formularioBloqueado" size="small" />
            </div>

            <el-input
              :data-testid="TEST_ID.GARANTIAS_REGISTRAR.INPUT_PATENTE_MARCA_MODELO"
              :placeholder="
                tienePatente
                  ? $t('GARANTIAS_nro_patente')
                  : $t('GARANTIAS_marca_modelo_unidad')
              "
              size="small"
              v-model="patente_marcaModelo"
              :disabled="formularioBloqueado"
              @blur="formatPatente"
            />
          </div>
        </div>
      </el-card>
      <el-card class="cardUsuario" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SECTION_DATOS_USUARIO">
        <div class="grid gridUsuario">
          <div class="cardTitle gridItem">
            {{ $t("GARANTIAS_datos_usuario") }}
          </div>
          <div class="nro_serie gridItem">
            <div class="label">{{ $t("GARANTIAS_razon_nombre") }}</div>
            <el-input
              :data-testid="TEST_ID.GARANTIAS_REGISTRAR.INPUT_RAZON_SOCIAL"
              :placeholder="$t('GARANTIAS_razon_nombre')"
              size="small"
              v-model="rz_soc"
              :disabled="formularioBloqueado"
            />
          </div>
          <div class="nro_serie_asoc gridItem">
            <div class="label">{{ $t("GARANTIAS_telefono") }}</div>
            <el-input
              :data-testid="TEST_ID.GARANTIAS_REGISTRAR.INPUT_TELEFONO"
              id="prueba"
              :placeholder="$t('GARANTIAS_telefono')"
              size="small"
              v-model="telefono"
              :disabled="formularioBloqueado"
              @input="onInput"
            />
          </div>
        </div>
      </el-card>
    </div>

    <div class="container_cards_canje" v-if="!guardado">
      <!-- es canje -->
      <el-card class="cardEquipo" :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SECTION_CANJE">
        <div class="grid cardBody">
          <div class="cardTitle gridItem">
            {{ $t("GARANTIAS_ti_canje") }}
          </div>
          <div class="patenteContainer">
            <div class="label">{{ $t("GARANTIAS_canje") }}</div>
            <el-switch
              :data-testid="TEST_ID.GARANTIAS_REGISTRAR.SWITCH_SOLICITA_CANJE"
              :disabled="habilitaCanje || formularioBloqueado"
              class="switch"
              v-model="solicitaCanje"
              size="small"
            />
          </div>
          <div>
            <div class="nota_canje" >
              <div v-if="!habilitaCanje" v-html="mensajeCanje"></div>
              <div v-else :data-testid="TEST_ID.GARANTIAS_REGISTRAR.TEXT_NO_ES_CANJEABLE">{{ $t("GARANTIAS_noEsCanjeable")  }}</div>
              <!--{{ this.mensajeCanje === '' || habilitaCanje === true ? this.notaCanje : this.mensajeCanje}}-->
            </div>
          </div>
          <div v-if="requiereImagenes">
            <div class="cardTitle_imagen gridItem">Imagenes</div>
            <el-row  :gutter="20">
              <el-col :span="24">
                <div class="label">Imagen 1</div>
                
                <FileUpload
                  name="imagen_1"
                  :limit="1"
                  :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                  :storeAction="'garantias/uploadImagen'"
                  :files="imagen_1"
                  :temporalId="id_solicitud_1"
                  :numeroArchivo="1"
                  :onFileListChange="imagenChanged"
                  :notifyPendingStatus="true"
                  :onFileNameChange="cambiaridImagen"
                  :withBtn="false"
                  :showPreview="true"
                  :garantia="true"
                  :maxSizeKB="maxTamanioImagenKB"
                  :uploadParams="{ ns: nro_serie }"
                  :comprimirImagenes="true"
                  :onMaxSizeKBChange="actualizarMaxTamanioImagen"
                  :disabled="formularioBloqueado"
                  style="text-align: left; margin-top: 5px"
                />
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <div class="label">Imagen 2</div>
                
                <FileUpload
                  name="imagen_2"
                  :limit="1"
                  :accept="',.jpg,.jpeg,.png,.tiff,.raw'"
                  :files="imagen_2"
                  :storeAction="'garantias/uploadImagen'"
                  :onFileListChange="imagenChanged"
                  :notifyPendingStatus="true"
                  :onFileNameChange="cambiaridImagen"
                  :temporalId="id_solicitud_2"
                  :numeroArchivo="2"
                  :withBtn="false"
                  :showPreview="true"
                  :garantia="true"
                  :maxSizeKB="maxTamanioImagenKB"
                  :uploadParams="{ ns: nro_serie }"
                  :comprimirImagenes="true"
                  :onMaxSizeKBChange="actualizarMaxTamanioImagen"
                  :disabled="formularioBloqueado"
                  style="text-align: left; margin-top: 5px"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-card>
    </div>

    <div class="btnContainer" v-if="!guardado">
      <el-button :data-testid="TEST_ID.GARANTIAS_REGISTRAR.BUTTON_GUARDAR" type="primary" @click="nuevaGarantia" :loading="loading" :disabled="subiendoImagenes">{{
        $t("GENERAL_saveBtn")
      }}</el-button>
      <router-link :to="{ name: 'Garantias', query: { keepFilter: 'true' } }">
        <el-button :data-testid="TEST_ID.GARANTIAS_REGISTRAR.BUTTON_CANCELAR">{{ $t("GENERAL_cancelBtn") }}</el-button>
      </router-link>
    </div>

    <!-- Secci�n datos guardados con exito -->
    <el-row :gutter="20" v-if="guardado" style="margin-top: 20px;">
      <el-col :span="24">
        <!-- en celular el título y el botón Nuevo van en filas separadas -->
        <el-row>
          <el-col :span="19" :xs="24">
            <div class="title">{{ $t("GARANTIAS_registro_exito") }}</div>
          </el-col>
          <el-col :span="4" :xs="24" class="colNuevo">
            <el-button
              @click="onNuevaGarantia"
              type="primary"
              icon="Plus"
              size="default"
              round
              >{{ $t("GENERAL_nuevo") }}</el-button
            >
          </el-col>
        </el-row>
        <!-- la garantía quedó registrada pero el back no pudo guardar las imágenes -->
        <el-alert
          v-if="registradaSinImagenes"
          class="alertaResultado"
          type="warning"
          show-icon
          :closable="false"
          :title="$t('GARANTIAS_registrada_sin_imagenes', { ns: nro_serie })"
        />
        <!-- datos guardados: grilla de dos columnas (etiqueta | valor) con todo el ancho del contenedor -->
        <el-card class="cardGuardado">
          <div class="cardTitle">{{ $t("GARANTIAS_datos_equipo") }}</div>
          <div class="datosGuardados">
            <div class="greyLabel">{{ $t("GARANTIAS_numero_serie") }}:</div>
            <div class="blackLabel">{{ nro_serie }}</div>

            <div class="greyLabel">{{ $t("GARANTIAS_ns_asoc") }}:</div>
            <div class="blackLabel">{{ $defaultEmpty(nro_serie_asoc) }}</div>

            <div class="greyLabel">{{ $t("GARANTIAS_fecha_instalacion") }}:</div>
            <div class="blackLabel">{{ fec_instalacion.toLocaleDateString() }}</div>

            <div class="greyLabel">{{ tienePatente ? $t("GARANTIAS_patente") : $t("GARANTIAS_marca_modelo") }}:</div>
            <div class="blackLabel">{{ patente_marcaModelo }}</div>
          </div>

          <hr />
          <div class="cardTitle">{{ $t("GARANTIAS_datos_usuario") }}</div>
          <div class="datosGuardados">
            <div class="greyLabel">{{ $t("GARANTIAS_razon_nombre") }}:</div>
            <div class="blackLabel">{{ rz_soc }}</div>

            <div class="greyLabel">{{ $t("GARANTIAS_telefono") }}:</div>
            <div class="blackLabel">{{ telefono }}</div>
          </div>

          <hr />
          <div class="cardTitle">{{ $t("GARANTIAS_ti_canje") }}</div>
          <div class="datosGuardados">
            <div class="greyLabel">{{ $t("GARANTIAS_canje") }}:</div>
            <div class="blackLabel">{{ solicitaCanje ? "SI" : "NO" }}</div>
          </div>
        </el-card>
        <el-row class="filaBotonesGuardado">
          <div>
            <el-button disabled="true">{{ $t("GENERAL_editBtn") }}</el-button>
            <router-link
              :to="{
                name: 'Garantias',
                query: { keepFilter: 'true', ns: this.nro_serie },
              }"
            >
              <el-button type="primary">{{
                $t("GENERAL_acceptBtn")
              }}</el-button>
            </router-link>
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NumeroSerieInput from "../NumeroSerieInput";
import {
  mostrarMensajeInternacionalizado,
  mostrarResultadoOperacion,
} from "../MensajeInternacionalizado";
import { showError, showWarning } from "../Mensaje";
import { ElMessageBox } from "element-plus";
import FileUpload from "@/components/FileUpload";
import TEST_ID from "@/testIds.json";

export default {
  name: "AltaGarantia",
  components: { NumeroSerieInput, FileUpload },
  data() {
    return {
      TEST_ID,
      nro_serie: "",
      nro_serie_valido: false,
      nro_serie_asoc: "",
      nro_serie_asoc_valido: false,
      patente_marcaModelo: "",
      fec_instalacion: new Date(),
      rz_soc: "",
      telefono: "",
      tienePatente: true,
      old_telefono: "",
      guardado: false,
      loading: false,
      asociarElemento: false,
      habilitaCanje: true,
      solicitaCanje: false,
      datosUsuario: {},
      mensajeCanje: "",
      requiereImagen: "N",
      notaCanje: "No es Canjeable",
      obs_img_1: "",
      obs_img_2: "",
      imagen_1: [],
      imagen_2: [],
      id_solicitud_1: "",
      id_solicitud_2: "",
      // mismo valor por defecto que MaxTamanioImagenKB en Garantías; se reemplaza por el configurado
      maxTamanioImagenKB: 10240,
      // el alta devolvió -22: la garantía quedó registrada sin imágenes y no se puede reenviar
      registradaSinImagenes: false,
    };
  },
  mounted() {
    this.getDatosUsuario();
    this.getConfiguracionImagenes();
  },
  watch: {
    tienePatente() {
      this.patente_marcaModelo = "";
    },
    nro_serie() {
      // las imágenes se suben asociadas al NS: si cambia, hay que volver a adjuntarlas
      if (this.guardado) return;
      if (this.imagen_1.length > 0 || this.imagen_2.length > 0) {
        this.imagen_1 = [];
        this.imagen_2 = [];
        showWarning(this.$t("GARANTIAS_imagenes_ns_cambiado"));
      }
    },
  },
  methods: {
    getDatosUsuario() {
      this.$store
        .dispatch("sesion/getDatosUsuario", this.idUsuario)
        .then((data) => {
          this.datosUsuario = data;
        });
    },
    getConfiguracionImagenes() {
      this.$store
        .dispatch("garantias/getConfiguracionImagenes")
        .then((data) => {
          if (data && data.CodigoResultado === 0 && data.Datos && data.Datos.MaxTamanioImagenKB > 0)
            this.maxTamanioImagenKB = data.Datos.MaxTamanioImagenKB;
        })
        // si falla se mantiene el valor por defecto; Garantías valida igual el tamaño
        .catch(() => {});
    },
    actualizarMaxTamanioImagen(maxTamanioImagenKB) {
      // Garantías rechazó una imagen por tamaño e informó su máximo vigente
      this.maxTamanioImagenKB = maxTamanioImagenKB;
    },
    cargaSerieCompleta(value) {
      if (value) {
        let payload = {
          p_NS: value.toString(),
          p_Clild: parseFloat(this.datosUsuario.Id),
        };
        this.$store
          .dispatch("solicitudes/getEsCanjeable", payload)
          .then((data) => {
            if (data) {
              console.log(data)
              if (data.EsCanjeable === "S") {
                this.habilitaCanje = false;
                this.mensajeCanje = this.formatMensaje(data.MensajeCanjeable);
                this.requiereImagen = data.RequiereImagen;
              } else {
                this.habilitaCanje = true;
              }
            }
          });
      }
    },
    formatMensaje(value){
      if(!value) return '';

      let formatted = value
      .replace(/\*([^*]+)/g, '� $1<br>') // Reemplazar asteriscos por vi�etas y a�adir saltos de l�nea
      .replace(/\n/g, '<br>'); // Asegurarse de que los saltos de l�nea se respeten
      return formatted;
    },
    onInput() {
      var regExp = /^(\(*[0-9]*\)*-*[0-9]*)*$/;
      var matches = regExp.exec(this.telefono);

      if (!matches) {
        this.telefono = this.old_telefono;
      } else this.old_telefono = this.telefono;
    },
    formatPatente() {
      if (this.tienePatente)
        this.patente_marcaModelo = this.patente_marcaModelo.split(" ").join("");
    },
    onNumeroSerieChange(payload) {
      this[payload.name] = payload.value;
      this[payload.name + "_valido"] = payload.valid;
    },
    nuevaGarantia() {
      // evito dobles envíos y guardar con imágenes subiéndose
      if (this.loading || this.subiendoImagenes) return;

      this.loading = true;

      // valido la garant�a
      if (!this.validate()) {
        this.loading = false;
        return;
      }

      // armo el payload
      let payload = {};
      payload.id_Usuario = this.idUsuario;
      payload.ns = this.nro_serie;
      payload.fecha_install = this.fec_instalacion;
      payload.razon_social = this.rz_soc;
      payload.telefono = this.telefono;
      payload.pat_motor =
        this.tienePatente === true ? this.patente_marcaModelo : "";
      payload.marca_modelo =
        this.tienePatente === false ? this.patente_marcaModelo : "";
      payload.ns_asociado = this.nro_serie_asoc;
      payload.solicitaCanje = this.solicitaCanje ? "S" : "N";
      // solo se envían las imágenes que se piden y se muestran en el formulario
      payload.imagenes = !this.requiereImagenes ? [] : [
        { archivo: this.imagen_1[0], numeroArchivo: 1 },
        { archivo: this.imagen_2[0], numeroArchivo: 2 }
      ]
        .filter(({ archivo }) => archivo && archivo.uploadStatus === "uploaded")
        .map(({ archivo, numeroArchivo }) => ({
          nombre_archivo: this.getNombreArchivo(archivo.name, numeroArchivo)
        }));

      // guardo la garant�a
      this.$store
        .dispatch("garantias/altaGarantia", payload)
        .then(
          (data) => this.procesarResultadoAlta(data),
          (error) => this.procesarErrorAlta(error)
        )
        .finally(() => (this.loading = false));
    },
    procesarResultadoAlta(data) {
      switch (data && data.CodigoResultado) {
        case 0:
          this.guardado = true;
          break;
        // quedó registrada sin imágenes: reintentar daría "ya registrada", así que se trata como registrada
        case -22:
          this.registradaSinImagenes = true;
          this.guardado = true;
          break;
        // no se registró: hay que volver a adjuntar las imágenes que no llegaron
        case -21:
          this.marcarImagenesFaltantes(data.Datos);
          showError(this.$t("GARANTIAS_imagenes_faltantes"));
          break;
        // no se registró: el back no pudo guardar las imágenes
        case -12:
          showError(this.$t("GARANTIAS_imagenes_no_guardadas"));
          break;
        // sesión o usuario inválido: el modal de sesión expirada lleva al login
        case -2:
        case -3:
          this.$store.commit("sesion/setSesionExpirada", true);
          break;
        // errores de la base (ej. NS ya registrado o inválido)
        default:
          mostrarResultadoOperacion(data);
      }
    },
    procesarErrorAlta(error) {
      const response = error && error.response;
      const status = response && response.status;

      // 401 y 403 ya los informa el interceptor de main.js
      if (status === 401 || status === 403) return;

      if (status === 400) {
        showError(this.$t("GARANTIAS_faltan_datos"));
      }
      // sin respuesta o error del servidor: no se sabe si quedó registrada
      else if (!response || status >= 500) {
        this.mostrarResultadoIncierto();
      }
      else {
        mostrarMensajeInternacionalizado(-1);
      }
    },
    mostrarResultadoIncierto() {
      // antes de volver a guardar conviene verificar en el listado si la garantía quedó registrada
      ElMessageBox.confirm(
        this.$t("GARANTIAS_alta_resultado_incierto", { ns: this.nro_serie }),
        this.$t("GENERAL_atencion"),
        {
          confirmButtonText: this.$t("GARANTIAS_ver_listado"),
          cancelButtonText: this.$t("GENERAL_closeBtn"),
          type: "warning",
          customClass: "modalResultadoIncierto",
        }
      )
        .then(() => this.$router.push({ name: "Garantias", query: { keepFilter: "true", ns: this.nro_serie } }))
        .catch(() => undefined);
    },
    marcarImagenesFaltantes(datos) {
      // el back devuelve los nombres faltantes (ej. "IMG_0001_1.jpg"): el número después del último "_" es el numeroArchivo
      const faltantes = (datos && datos.Faltantes) || [];
      const numerosFaltantes = faltantes.map((nombre) => {
        const base = String(nombre).replace(/\.[^.]*$/, "");
        return Number(base.substring(base.lastIndexOf("_") + 1));
      });
      // si no se puede identificar cuáles faltan, pido volver a adjuntar todas
      const numeros = [1, 2].filter((numero) => numerosFaltantes.includes(numero));
      (numeros.length > 0 ? numeros : [1, 2]).forEach((numero) => {
        const lista = this[`imagen_${numero}`];
        if (lista && lista.length > 0)
          this[`imagen_${numero}`] = lista.map((imagen) => ({ ...imagen, uploadStatus: "failed", uploading: false, error: true }));
      });
    },
     getNombreArchivo(nombreOriginal, numeroArchivo) {
      // armo el nombre del archivo (ejemplo Id_solic_servicio + �_�+_numero_archivo.jpg)
      let numeroSolicitud = nombreOriginal.split(".")[0];
      let extensionArchivo = nombreOriginal.split(".").pop();

      return `${numeroSolicitud}_${numeroArchivo}.${extensionArchivo}`;
    },
    onNuevaGarantia() {
      this.$router.go();
    },
    validate() {
      let valida = true;

      if (!this.nro_serie || !this.nro_serie_valido) {
        showError(this.$t("GENERAL_missing_nro_serie"));
        valida = false;
      }

      if (this.nro_serie_asoc && !this.nro_serie_asoc_valido) {
        showError(this.$t("GENERAL_missing_nro_serie_asoc"));
        valida = false;
      }

      if (!this.fec_instalacion) {
        showError(this.$t("GENERAL_missing_fec_instalcion"));
        valida = false;
      }

      if (!this.patente_marcaModelo) {
        let mensaje =
          this.tienePatente === true
            ? this.$t("GENERAL_missing_patente")
            : this.$t("GENERAL_missing_marca_modelo");
        showError(mensaje);
        valida = false;
      }

      if (!this.rz_soc) {
        showError(this.$t("GENERAL_missing_rz_soc"));
        valida = false;
      }

      if (!this.telefono) {
        showError(this.$t("GENERAL_missing_telefono"));
        valida = false;
      }

      if (this.requiereImagenes) {
        const imagenes = [
          this.imagen_1 && this.imagen_1[0],
          this.imagen_2 && this.imagen_2[0]
        ]
        // informo qué imagen no está lista para que el usuario la reemplace
        imagenes.forEach((imagen, index) => {
          if (imagen && imagen.uploadStatus === "pending") {
            showError(this.$t("GARANTIAS_imagen_pendiente", { numero: index + 1 }));
            valida = false;
          }
          else if (imagen && imagen.uploadStatus !== "uploaded") {
            showError(this.$t("GARANTIAS_imagen_fallida", { numero: index + 1 }));
            valida = false;
          }
        });
        if (imagenes.some((imagen) => !imagen)) {
          showError(this.$t("GENERAL_missing_imagen_garantia"));
          valida = false;
        }
      }

      return valida;
    },
    
     imagenChanged(name, fileList) {
      switch (name) {
        case "imagen_1":
          this.imagen_1 = fileList;
          break;
        case "imagen_2":
          this.imagen_2 = fileList;
          break;
      }
    },
  },
  computed: {
    ...mapState({
      idUsuario: (state) => state.sesion.resultadoAutenticacion.IdUsuario,
    }),
    formularioBloqueado() {
      return this.loading;
    },
    requiereImagenes() {
      return this.habilitaCanje === false && this.solicitaCanje && this.requiereImagen === "S";
    },
    subiendoImagenes() {
      return [this.imagen_1, this.imagen_2].some(
        (lista) => lista && lista.some((imagen) => imagen.uploadStatus === "pending")
      );
    },
  },
};
</script>

<style scoped>
.container_card_guardado {
  display: flex;
  text-align: center !important;
  align-items: center;
}
.cardGuardado {
  text-align: left;
  margin-bottom: var(--ds-space-3);
}
.cardGuardado .cardTitle {
  margin-bottom: var(--ds-space-3);
}
.cardGuardado hr {
  margin: var(--ds-space-4) 0;
  border: none;
  border-top: 1px solid var(--ds-color-neutral-200);
}
/* mismo corte que :xs de Element Plus: el botón Nuevo queda debajo del título */
@media (max-width: 767px) {
  .colNuevo {
    margin-bottom: var(--ds-space-4);
  }
  .filaBotonesGuardado {
    justify-content: center;
  }
}
/* etiqueta | valor: la etiqueta toma el ancho que necesita sin partir el valor */
.datosGuardados {
  display: grid;
  grid-template-columns: minmax(180px, 40%) 1fr;
  column-gap: var(--ds-space-4);
  row-gap: var(--ds-space-2);
  align-items: baseline;
}
@media (max-width: 600px) {
  .datosGuardados {
    grid-template-columns: 1fr;
    row-gap: 0;
  }
  .datosGuardados .blackLabel {
    margin-bottom: var(--ds-space-2);
  }
}
.cardBody {
  padding-left: 25px;
}

.greyLabel {
  font-size: 14px;
  color: #6b6b6b;
  text-align: left;
  font-weight: normal;
}
.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}
.container {
  padding: 0 30px;
  max-width: 800px;
  margin: 0 auto;
}

@media (max-width: 600px) {
  .container {
    padding: 10px 0px;
  }
}
.title {
  font-size: 24px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
  margin-bottom: 20px;
}
@media (max-width: 800px) {
  .title {
    text-align: center;
  }
}
.container_cards {
  display: flex;
}

.nota_canje {
  margin-top: 10px;
  text-align: left !important;
}

.container_cards_canje {
  margin-top: 10px;
  display: flex;
}
.cardEquipo {
  flex: 50%;
}
.cardUsuario {
  flex: 50%;
  margin-left: 20px;
}

@media (max-width: 1000px) {
  .container_cards {
    flex-direction: column;
  }
  .cardUsuario {
    flex: 50%;
    margin-top: 20px;
    margin-left: 0;
  }
}
.cardTitle_imagen {
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: black;
  margin-top: 15px;
}
.cardTitle {
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  color: black;
}
.label {
  text-align: left;
  margin-top: 15px;
  margin-bottom: 4px;
  font-size: 14px;
}
.labelBold {
  margin-top: 10px;
  text-align: left;
  font-size: 15px;
  font-weight: bold;
}
.labelGuardado {
  margin-top: 10px;
  margin-left: 2px;
  text-align: left;
  font-size: 14px;
}
.switch {
  float: right;
  margin-top: 20px;
}
.fec_instalacion {
  grid-column-start: 2;
  grid-row-start: 2;
}
.patente {
  grid-column-start: 3;
  grid-row-start: 2;
}
.labelError {
  margin-top: 15px;
}
.error {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
/* aviso con la paleta de advertencia del design system en lugar de los colores de Element Plus */
.alertaResultado.el-alert--warning.is-light {
  --el-alert-bg-color: var(--ds-color-warning-50);
  margin-bottom: var(--ds-space-3);
  padding: var(--ds-space-3) var(--ds-space-4);
  border: 1px solid var(--ds-color-warning-200);
  color: var(--ds-color-warning-900);
  text-align: left;
}
.alertaResultado :deep(.el-alert__icon) {
  color: var(--ds-color-warning-400);
}
.btnContainer {
  margin-top: 10px;
  /* white-space: nowrap; */
}
.grid,
.gridUsuario {
  display: flex;
  flex-direction: column;
  padding: 20px 0px;
}
.gridUsuario {
  grid-template-rows: 1fr 1fr;
}

.fec_instalacion {
  grid-column-start: 2;
  grid-row-start: 3;
}
.patente {
  grid-column-start: 2;
  grid-row-start: 4;
}

.patenteContainer {
  display: inline-flex;
  width: 100%;
}
.patenteContainer .label {
  float: left;
  width: calc(100% - 40px);
}
.patenteContainer .switch {
  margin-top: 12px;
}

@media (max-width: 900px) {
  .grid,
  .gridUsuario {
    display: flex;
    flex-direction: column;
  }
  .gridItem {
    flex: 1;
    padding: 8px;
  }
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: -webkit-fill-available;
}

.descripcion {
  text-align: left;
  font-size: 12px;
  margin-top: 10px;
  color: #666;
}
.descripcion.invalido {
  color: #f44336;
}

.guardado {
  width: 50%;
}
.container_cards {
  display: flex;
}
</style>

<style>
/* modal de resultado incierto del alta: ElMessageBox se monta en el body, por eso no puede ser scoped */
.modalResultadoIncierto {
  --el-messagebox-width: 520px;
  --el-messagebox-padding-primary: var(--ds-space-6);
}
.modalResultadoIncierto .el-message-box__status.el-message-box-icon--warning {
  --el-messagebox-color: var(--ds-color-warning-400);
}
.modalResultadoIncierto .el-message-box__content {
  padding: var(--ds-space-3) 0 var(--ds-space-2);
}
.modalResultadoIncierto .el-message-box__message {
  line-height: 1.6;
}
.modalResultadoIncierto .el-message-box__btns {
  padding-top: var(--ds-space-4);
}

.altaGarantia .nro_serie_asoc {
  grid-column-start: 2;
  grid-row-start: 2;
}

@media (max-width: 900px) {
  .altaGarantia .gridItem {
    flex: 1;
    padding: 8px;
  }
}
</style>